module.exports = __webpack_public_path__ + "static/media/milagros.86378962.jpeg";